import { useRef } from 'react';
import { IMAGE_FRAME_CHOICES, type ImageFrameStyle } from './sourceLayer';
import './imageFramePicker.css';

export function ImageFramePicker({value,onChange,disabled=false,preferredStyle}:{value:ImageFrameStyle;onChange:(value:ImageFrameStyle)=>void;disabled?:boolean;preferredStyle?:Exclude<ImageFrameStyle,'none'>}) {
  const remembered=useRef<Exclude<ImageFrameStyle,'none'>>('simpleBorder');
  if(value!=='none')remembered.current=value;
  return <div className="image-frame-effect">
    <button type="button" className="painting-source-effect" aria-label="Borders / Frames" aria-pressed={value!=='none'} disabled={disabled} onClick={()=>onChange(value==='none'?(preferredStyle??remembered.current):'none')}>Frame</button>
    {value!=='none'&&<select className="image-frame-style" aria-label="Image frame style" value={value} disabled={disabled} onChange={event=>onChange(event.target.value as Exclude<ImageFrameStyle,'none'>)}>{IMAGE_FRAME_CHOICES.slice(1).map(([style,label])=><option key={style} value={style}>{label}</option>)}</select>}
  </div>;
}
